import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgInstantConfirmFlat = (props: SVGProps<SVGSVGElement>) => (
  <svg
    className="instant-confirm-flat_svg__instant-confirm-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 11 22"
    {...props}
  >
    <defs>
      <linearGradient
        id="instant-confirm-flat_svg__a"
        x1="50%"
        x2="50%"
        y1="100%"
        y2="0%"
      >
        <stop offset="0%" stopColor="#5BC9F5" />
        <stop offset="100%" stopColor="#2080F1" />
      </linearGradient>
    </defs>
    <path
      fill="url(#instant-confirm-flat_svg__a) #009df9"
      fillRule="evenodd"
      d="m291.237 3071-9.075 12.238 3.218.19-1.276 8.959 8.898-12.964-2.936-.202z"
      transform="translate(-282 -3071)"
    />
  </svg>
);
const Memo = memo(SvgInstantConfirmFlat);
export default Memo;
